import { Element, useNode } from "@craftjs/core";
import React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";

import {
  CenteredHeader,
  ContentWrapper,
  PaddingWrapper,
} from "./gallery-component-styles";
import Settings from "./settings";

export interface GalleryProps {
  columns?: number;
  children: React.ReactNode;
  className?: string;
}

export default function Gallery({
  children,
  columns = 3,
  className,
}: GalleryProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={nodeId}
      className={className}
    >
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth="1440px">
          <CenteredHeader>
            <Element
              id="speakers-title"
              is={Text}
              element="h2"
              text="Join our first digital conference."
              pattern="headingTwo"
              data-testid="speakers-title"
            />
          </CenteredHeader>
          <ContentWrapper columns={columns}>{children}</ContentWrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Gallery.craft = {
  isCanvas: true,
  custom: {
    displayName: "Gallery",
  },
  related: {
    settings: Settings,
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
